import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, ComponentFactoryResolver, AfterViewInit } from '@angular/core';
import { PlotCoreObject } from '../asp/PlotCoreObject';
import { IAro, AppInjector } from '../common/inject';
import { AroService } from './aro.service';
import * as aspObjects from '../asp/aspObjects';
import * as utils from '../common/utils';
import * as units from '../common/units';
import * as consts from '../common/consts';
import * as aro from './aro';
import * as settings from '../common/settings';
import * as enums from '../common/enums';
import { ZIndexMngr } from '@core_n/common/ZIndexMngr';
import { MatDialogRef } from '@angular/material/dialog';
import { AroPlotComponent } from '../../../app/aro/aro-plot.component';
import { mainMapMngr } from '../asp/MapMngr';
import { Point } from '@core_n/common/Point';
import { Animations } from '@core_n/Animations';


@Component({
  templateUrl: './aro-plot-core.component.html',
  styleUrls: ['./aro.component.scss'],
  animations: [
    Animations.WindowOpenCloseFadeHeight
  ]
})
export class AroPlotCoreComponent extends ZIndexMngr implements IAro, OnInit, AfterViewInit {
  public shown: boolean = false;
  public extraDataNumRows: number = 0;
  public extraDataNumColumns: number = 0;

  public identityColor: string;
  public plotSymbol: string;
  public majorStr: string = "NAME";
  public majorPlaceholder: string = "NAME PLACEHOLDER";

  public snsSic: number = 0;
  public snsSac: number = 0;

  public offlinePlotLoc: Point;

  public plotId: number;
  public CorrelationType: string = aro.NO_VALUE;
  public altitude: string = aro.NO_VALUE;
  public altitudeUnits: string = "";
  public time: string;
  public radar: string;
  public location: string;
  public locUnits: string;
  public age: number = 0;
  public ageC: number = 0;
  public range: string;
  public elevation: string = aro.NO_VALUE;
  public azimuth: string = aro.NO_VALUE;
  public is2D: string = aro.NO_VALUE;

  //MODES
  public mode1: string;
  public mode2: string;
  public mode3: string;
  public mode4: string;
  public modeC: string;
  public modeSAcIdent: string;
  public modeSAddress: string;
  public modeSAltitude: string;
  public modeSSpeed: string;

  public plotSym: string = "?";
  public plot: PlotCoreObject = null;
  public deadmsg: string = "";

  // properties
  public letter: boolean = false;

  // constructor(private aroService: AroService,
  //             private cdref: ChangeDetectorRef) {
  //   let self = this;
  //   setInterval(function () { self.refresh() }, consts.DIALOG_REFRESH_INTERVAL);
  // }

  @ViewChild('speedCircle', { read: ElementRef, static: true }) speedCircle: ElementRef;

  constructor(
    private aroService: AroService,
    private cdref: ChangeDetectorRef,
    elementRef: ElementRef,
    public dialogRef: MatDialogRef<AroPlotComponent>) {
    super(elementRef);

    if (settings.userSettings.userPerm == enums.Permission.USER)
      this.hideAro();

    let self = this;
    this.locUnits = enums.CoordinateTypeTitle(settings.userSettings.coordinatesType);
    setInterval(function () { self.refresh() }, consts.DIALOG_REFRESH_INTERVAL);
  }

  ngOnInit(): void {
    this.aroService.setPlotAro(this);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.windowVisible.next(true);
    })
  }

  protected refresh(): void {
    this.updateLocation();
    if (this.plot != null) {
      if (!this.plot.active()) {
        this.plot = null;
        this.shown = false;
      }
      else {

        // let age = aspObjects.plotsPool.getSlotAge(this.slotNumber);
        this.age = aspObjects.plotsPool.getSlotAge(this.plot.slotNumber);
        this.plotId = this.plot.plotID;
        this.time = this.plot.timeStr;
        this.CorrelationType = enums.PlotCorrTitle(this.plot.CorrelationType);

        if (this.plot.geometry != null) {
          this.offlinePlotLoc = this.plot.geometry;
        }

        // Display Settings
        this.letter = settings.userSettings.plotDisplaySymbol;
        this.plotSym = this.plot.sensorLetter;
        this.identityColor = utils.newmiColorToString(this.plot.getColor());
        this.plotSymbol = utils.getPlaneSymbol(this.plot.symbol);

        // if (this.plot.isCorrelated) {
        //   this.plotSymbol = utils.getPlaneSymbol("plot-corr");
        // }
        // else {
        //   this.plotSymbol = utils.getPlaneSymbol("plot-uncorr");
        // }

        // Sensor Data
        this.snsSic = this.plot.sic;
        this.snsSac = this.plot.sac;
        // old
        // this.radar = this.plot.sensorID + `(${aspObjects.sensorsPool.getSensorLetterBySensorID(this.plot.sensorID)})`;
        this.radar = this.plot.sensorID + ' (' + this.plot.sensorLetter + ')';
        //2D3D
        this.is2D = this.plot.is2D ? "True" : "False";

        // Dynamics
        if (!this.plot.is2D) {
          this.elevation = (this.plot.elevation * units.RAD_TO_DEG).toFixed(3).toString();
          this.altitude = typeof this.plot.geometry.z == 'undefined' ? aro.NO_VALUE : units.altitudeValue(this.plot.geometry.z, true);
          this.altitudeUnits = units.altitudeUnits();
        }
        this.range = (this.plot.range).toString();
        this.azimuth = (this.plot.azimuth * units.RAD_TO_DEG).toFixed(3).toString();

        // age
        if (this.age > settings.userSettings.plotTrailLength) {
          this.deadmsg = "(Deceased)";
          this.plot = null;
        }
      }
    }
    else {
      this.shown = false;
      this.dialogClosed();
      this.dialogRef.close();
    }
  }

  public showAro(objectId): boolean {
    let plot = <PlotCoreObject>aspObjects.plotsPool.getObject(objectId);
    if (plot) {
      let sensor = aspObjects.sensorsPool.getSensorBySensorID(this.plot.sensorID);

      this.plot = plot;

      this.plotId = this.plot.plotID;
      this.time = this.plot.timeStr;
      this.radar =
        `${sensor.sac} | ${sensor.sic}  (` +
        `${sensor.sensorLetter})`;

      this.plotSym = this.plot.sensorLetter;
      this.shown = true;
      this.onShowAro();
      this.refresh();
      this.cdref.detectChanges();
    }
    return plot != null;
  }

  protected onShowAro() { }

  public hideAro() {
    this.plot = null;
    this.shown = false;
  }

  public isShown(): boolean {
    return this.shown;
  }

  public getShownId() {
    if (this.plot == null)
      return null;
    else
      return this.plot.id;
  }

  updateLocation() {
    if (this.offlinePlotLoc)
      this.location = utils.getCoordinatesString(this.offlinePlotLoc);
  }

  extraDataLabel(row: number, column: number) {
    return '';
  }

  extraDataUnits(row: number, column: number) {
    return '';
  }

  extraDataValue(row: number, column: number) {
    return '';
  }

  // Close button callback
  onCloseBtnClick() {
    this.hideAro();
  }

  onMajorInput(str: string) {
    if (str.length > 24)
      return;
    this.plot.plotName = str;
    this.majorStr = str;
  }

  locationClick() {
    this.aroService.locationClick();
    this.locUnits = enums.CoordinateTypeTitle(settings.userSettings.coordinatesType);
  }

  onCenterBtnClick() {
    if (this.plot == null)
      return;
    mainMapMngr.setMapCenter(this.plot.geometry);
  }

  getID() {
    return this.plot.id;
  }

  setLocationClick() {
    mainMapMngr.activateMapEventsTool(this.onMapEvent.bind(this), [NeWMI.Map.Enums.EMapEvents.MouseDown]);
  }

  private onMapEvent(evt: NeWMI.Map.Events.MouseEvents) {
    let coord = { x: evt.mapPoint.x, y: evt.mapPoint.y };
    mainMapMngr.activateDefaultTool();
  }
}

var aroPlotComponentFactory;
export function setAroPlotComponentFactory(factory) {
  aroPlotComponentFactory = factory;
}
export function getAroPlotComponentFactory() {
  if (aroPlotComponentFactory == undefined)
    aroPlotComponentFactory = AppInjector.get(ComponentFactoryResolver).resolveComponentFactory(AroPlotCoreComponent);
  return aroPlotComponentFactory;
}
